import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "#4f4f4f",
	height: 12,
	viewBox: "0 0 12 12",
	width: 12,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m.75 9.1845v1.7733c0 .1634.128333.2917.29167.2917h1.77333c.07583 0 .15167-.0292.20417-.0875l6.37-6.36416-2.1875-2.1875-6.36417 6.36416c-.058333.05834-.0875.12834-.0875.21zm10.3308-6.07833c.2275-.2275.2275-.595 0-.8225l-1.36497-1.364998c-.2275-.2275-.595-.2275-.8225 0l-1.0675 1.067498 2.18747 2.1875z" })
});
export { SvgEdit as ReactComponent };
